"use strict";

import BetragsrechnerRegistry from "../services";

import BetragsrechnerPersonalkosten from "./betragsrechner.js";
import BetragsrechnerPersonalkostenController from "./controller";

const BetragsrechnerPersonalkostenModul = angular.module("dias.betragsrechner.personalkosten", [
  BetragsrechnerRegistry.name,
]);

BetragsrechnerPersonalkostenModul.config(/*@ngInject*/ BetragsrechnerRegistryProvider => {
  BetragsrechnerRegistryProvider.register("personalkosten", BetragsrechnerPersonalkosten);
})
  .component("personalkosten", BetragsrechnerPersonalkostenController);

export default BetragsrechnerPersonalkostenModul;
